import React from "react";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { useState } from "react";
import { useParams } from "react-router";
import { useEffect } from "react";
import LoadingPage from "../../../Components/layouts/loading";
import Footer from "../../../Components/Footer/footer";
import { PiPlantLight } from "react-icons/pi";
import StepRoutes from "../../../Routes/steps_routes";
import { useSelector } from "react-redux";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

function Viewharvest() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const store = useSelector((store) => store.login.user);
  // const [imageUrls, setImageUrls] = useState({});

  // useEffect(() => {
  //   if (data) {
  //     if (data?.uploadProductPhoto) {
  //       getUplodedImage(
  //         setImageUrls,
  //         data?.uploadProductPhoto,
  //         "uploadProductPhoto"
  //       );
  //     }
  //   }
  // }, [data]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/harvest/getHarvestById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })

      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <PiPlantLight
                    className="fs-2 me-1"
                    style={{ color: "green" }}
                  />{" "}
                  View Harvest
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end"></div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div class="table-responsive">
                  <table class="table table-vcenter card-table table-striped">
                    <thead>
                      <tr>
                        <th>Specification</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {store.Role !== process.env.REACT_APP_ROLE_CLIENT &&
                        data && (
                          <tr>
                            <td>Project Name</td>
                            <td>{(data?.farmName || "N/A").toUpperCase()}</td>
                          </tr>
                        )}
                      {store.Role !== process.env.REACT_APP_ROLE_CLIENT &&
                        data && (
                          <tr>
                            <td>Project Address</td>
                            <td>
                              {(data?.projectAddress || "N/A").toUpperCase()}
                            </td>
                          </tr>
                        )}
                      {store.Role !== process.env.REACT_APP_ROLE_CLIENT &&
                        data && (
                          <tr>
                            <td>Contact</td>
                            <td>
                              {(data?.clientPhoneNumber || "N/A").toUpperCase()}
                            </td>
                          </tr>
                        )}
                      {data && (
                        <tr>
                          <td>Harvest Date</td>
                          <td>{(data?.harvestDate || "N/A").toUpperCase()}</td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Crop</td>
                          <td>{(data?.selectCrop || "N/A").toUpperCase()}</td>
                        </tr>
                      )}

                      {data && (
                        <tr>
                          <td>Uploaded product photo</td>
                          <td>
                            {data?.uploadProductPhoto ? (
                              <LazyImageComponent
                                width="150px"
                                src={data?.uploadProductPhoto}
                                alt={data?.uploadProductPhoto}
                              />
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Harvest Quantity</td>
                          <td>
                            {(data?.harvestQuantity || "N/A").toUpperCase()}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Transportation</td>
                          <td>
                            {(data?.transportation || "N/A").toUpperCase()}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Packaging Type</td>
                          <td>
                            {(data?.packagingType || "N/A").toUpperCase()}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Selling Price (Kg)</td>
                          <td>₹{data?.sellingPricePerKg || "N/A"}</td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Total Harvest Price</td>
                          <td>₹{data?.totalHarvestPrice || "N/A"}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="card-footer">
                  <div className="btn-list justify-content-end">
                    <SimpleButton
                      buttonText="Edit Harvest"
                      href={`/farm-harvest-management/edit/${id}`}
                    />
                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}

export default Viewharvest;
